var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0611 10L16.2676 4.79395C16.5605 4.50098 16.5605 4.02637 16.2676 3.7334C15.9746 3.44043 15.5 3.44043 15.207 3.7334L10.0005 8.93945L4.79395 3.7334C4.50098 3.44043 4.02637 3.44043 3.7334 3.7334C3.44043 4.02637 3.44043 4.50098 3.7334 4.79395L8.93988 10L3.7334 15.206C3.44043 15.499 3.44043 15.9736 3.7334 16.2666C3.87988 16.4131 4.07178 16.4863 4.26367 16.4863C4.45556 16.4863 4.64746 16.4131 4.79394 16.2666L10.0005 11.0605L15.207 16.2666C15.3535 16.4131 15.5454 16.4863 15.7373 16.4863C15.9292 16.4863 16.1211 16.4131 16.2676 16.2666C16.5605 15.9736 16.5605 15.499 16.2676 15.206L11.0611 10Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.597f8a9521c1f868f120eab42eccef20.svg";
export { ForwardRef as ReactComponent };